module.exports = {
  siteUrl: 'https://hedihidouri.me',
  email: 'hedyalhidoury@gmail.com',
  whatsappNumber: '33675424015',
  whatsappLink: 'https://wa.me/33675424015',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/hedi-hidouri-6b956a77/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Expertise',
      url: '/#services',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#42d6c4',
    navy: '#0c1529',
    darkNavy: '#070f1d',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
